module.exports = __webpack_public_path__ + "static/media/img2.2a7a690e.jpg";